import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../../public/assets/icon/slide_down_gray.png'
import _imports_1 from '../../../../public/assets/icon/slide_up_gray.png'
import _imports_2 from './assets/art-inside-banner.png'
import _imports_3 from './assets/nft-inside-banner.png'


const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 쉽고, 안전하게")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 모든 자산 투자의")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 첫걸음 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 기존의 방식으로는 경제적 목표를 달성하기 어려운 시대,")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 일부 자산가와 기관 투자자에게만 열려있는")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 불평등한 기회 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 엔젤리그는 자본주의 사회의 주도적 구성원에게 평등하고 혁신적인 경제 활동 방법을 제안합니다.")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 경제적 자유를 이룰 수 있도록.. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 스타트업 비상장주식, 미술품, NFT(대체불가 토큰) 등 다양한 투자 자산군을 경험해 보세요. ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 비상장주식 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 스타트업 주식 거래시 고액 투자만 가능한 점,")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 불법 브로커로 인한 높은 위험성 등의 문제점을 제거한 쉽고, 안전한 비상장주식 거래 서비스를 경험할 수 있습니다. ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 간단한 클릭 몇 번으로 클럽딜에 참여하여 누구나 소액으로 유니콘의 주주가 될 수 있어요. ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 안전성을 높이기 위해 Pre-IPO 단계의 스타트업에 집중합니다. ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 스타트업의 주주가 되는 것은 투자의 측면에서 보았을 때 아주 큰 위험이 따릅니다. 엔젤리그 조합 출자금은 원금 회수가 보장되지 않습니다. ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 엔젤리그는 위험 감소를 위해, 스타트업 중 Pre-IPO(기업공개 직전) 단계로 최소한의 안정성을 확보한 회사의 매물인지 확인하고 안내합니다. ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 펼쳐보기 ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"20px","margin-top":"2px"}
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 리드엔젤 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" '리드엔젤'은 본인이 투자하고 싶은 비상장주식 클럽딜 오픈을 위해 판매자와 가격 협상을 할 수 있습니다. 엔젤리그에 등록된 물량은 모두 판매자가 직접 올리고, 엔젤리그가 보유 여부를 확인한 안전 물량입니다. 합리적인 가격 결정은 리드엔젤과 판매자간의 합의로 이루어 집니다. '리드엔젤' 자격은 가입 후 일정 기간이 지나고, 클럽딜에 참여한 이력이 있는 분들에게만 주어지며, MY페이지 상단에 날개 표시로 확인 가능합니다. ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 엔젤리그 플랫폼이 안전한 거래를 관리합니다. ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" (주)엔젤리그가,")
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("ul", { style: {"margin-left":"-8px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "각 조합의 감사로서 조합을 실시간 관리합니다."),
  /*#__PURE__*/_createElementVNode("li", null, "리드엔젤이 확보한 물량의 매도자를 확인하고, 주식 보유 여부를 확인합니다."),
  /*#__PURE__*/_createElementVNode("li", null, "조합의 생성, 규약작성 등의 업무를 지원합니다."),
  /*#__PURE__*/_createElementVNode("li", null, "조합의 명의개서를 지원합니다.")
], -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 접기 ")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"20px","margin-top":"2px"}
}, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 미술품 ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 높은 수수료와 접근이 부족한 투자 정보로 접근이 어려웠던 미술품 거래가 아닌 기분 좋게 경험할 수 있는 미술품 재테크를 제안합니다. ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 충분한 투자 정보 제공과 부담없는 수수료는 물론, 최근 가치가 오르고 있는 작가의 작품들로 엄선한 미술품을 엔젤리그에서 만나볼 수 있습니다. ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" NFT ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 엔젤리그 NFT는 기술 기반의 Minting & Marketing 플랫폼으로서 대체 불가한 디지털 자산 NFT 시장에 참여를 제안합니다. ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" 크리에이터에게는 혼자 하기 힘든 NFT를 발행 서비스를 제공하고, 컬렉터들을 통해 거래되며 가치가 상승할 수 있도록 지원합니다. ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 첫 투자 접근이 어려운 NFT 시장에 쉽고, 안전한 투자 경험을 제안합니다. ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)

import {AgBoxS, AgIconS, AgTextS} from '@/components/ag'
import {ref} from 'vue'
import AgTextLogo from '../../ag/AgTextLogo.vue'
// import ArtInsideBanner from './assets/art-inside-banner.svg'
// import NftInsideBanner from './assets/nft-inside-banner.svg'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isOpen = ref(false)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), {
    class: "content-wrapper",
    css: {mt: 32, wordBreak: 'keep-all'}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), {
        class: "info-general",
        css: {pr:20, pl:20,pb:32}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), {
            class: "info-general-title",
            css: {typography:'tit24b'}
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { class: "info-general-content" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_unref(AgBoxS), { css: {typography: 'tit16b'} }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode(_unref(AgBoxS), { css: {typography: 'tit16b'} }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), {
        class: "info-stock",
        css: {backgroundColor: 'bg1', pt: 40, pr:20, pl:20}
      }, {
        default: _withCtx(() => [
          _createVNode(AgTextLogo, { name: "default" }),
          _createVNode(_unref(AgBoxS), {
            class: "info-stock-title",
            css: {typography:'tit24b', mt:25}
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { class: "info-stock-content" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), {
                class: "info-stock-content-detail",
                css: {position: 'relative'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AgBoxS), {
                    css: {backgroundColor: 'bg2', padding:20, mt:16, pb: (isOpen.value ? 20 : 32), mb: (isOpen.value ? 4 : 0)}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(AgBoxS), { css: {typography: 'tit16b'} }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:16} }, {
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:16} }, {
                        default: _withCtx(() => [
                          _hoisted_22
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["css"]),
                  (isOpen.value === false)
                    ? (_openBlock(), _createBlock(_unref(AgBoxS), {
                        key: 0,
                        class: "summary-button-closed",
                        css: {typography: 'text14r', color: 'gray2'},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _hoisted_24
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isOpen.value===true)
                    ? (_openBlock(), _createBlock(_unref(AgBoxS), {
                        key: 1,
                        class: "info-stock-content-detail-more"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(AgBoxS), { css: {backgroundColor: 'bg2', padding:20, mb: 4} }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(AgBoxS), { css: {typography: 'tit16b'} }, {
                                default: _withCtx(() => [
                                  _hoisted_25
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:16} }, {
                                default: _withCtx(() => [
                                  _hoisted_26
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(AgBoxS), { css: {backgroundColor: 'bg2', padding:20, mb: 32} }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(AgBoxS), { css: {typography: 'tit16b'} }, {
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:16,} }, {
                                default: _withCtx(() => [
                                  _hoisted_28,
                                  _hoisted_29,
                                  _hoisted_30
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (isOpen.value===true)
                ? (_openBlock(), _createBlock(_unref(AgBoxS), {
                    key: 0,
                    css: {typography: 'text14r', color: 'gray2', dp:'flex', width: '100%', alignItems: 'center', justifyContent: 'center', pb:16},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = !isOpen.value))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31,
                      _hoisted_32
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), {
        class: "info-art",
        css: {backgroundColor: '#ECEAFA', pt: 40, pr:20, pl:20, pb:32}
      }, {
        default: _withCtx(() => [
          _createVNode(AgTextLogo, { name: "art" }),
          _createVNode(_unref(AgBoxS), {
            class: "info-art-title",
            css: {typography:'tit24b', mt:25}
          }, {
            default: _withCtx(() => [
              _hoisted_33
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { class: "info-art-content" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_34
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {mt: 16} }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), {
        class: "info-nft",
        css: {backgroundColor: '#F3F5FF', pt: 40, pr:20, pl:20, pb:32}
      }, {
        default: _withCtx(() => [
          _createVNode(AgTextLogo, { name: "nft" }),
          _createVNode(_unref(AgBoxS), {
            class: "info-nft-title",
            css: {typography:'tit24b', mt:25}
          }, {
            default: _withCtx(() => [
              _hoisted_37
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { class: "info-nft-content" }, {
            default: _withCtx(() => [
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_39
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {typography: 'text16r', mt:32} }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 1
              }),
              _createVNode(_unref(AgBoxS), { css: {mt: 16} }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), {
        class: "info-footer",
        css: {dp:'flex', margin: '40px 0px', justifyContent: 'center'}
      }, {
        default: _withCtx(() => [
          _createVNode(AgTextLogo, { name: "default" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})